import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Admin pages
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminPostsPage = lazy(() => import('../pages/admin/posts/page'));
const AdminPostEditPage = lazy(() => import('../pages/admin/posts/edit/page'));
const AdminHomePage = lazy(() => import('../pages/admin/home/page'));
const AdminSeriesPage = lazy(() => import('../pages/admin/series/page'));
const AdminCategoriesPage = lazy(() => import('../pages/admin/categories/page'));
const AdminSettingsPage = lazy(() => import('../pages/admin/settings/page'));

const HomePage = lazy(() => import('../pages/home/page'));
const PostsPage = lazy(() => import('../pages/posts/page'));
const PostDetailPage = lazy(() => import('../pages/posts/[slug]/page'));
const CategoriesPage = lazy(() => import('../pages/categories/page'));
const CategoryDetailPage = lazy(() => import('../pages/categories/[slug]/page'));
const SeriesPage = lazy(() => import('../pages/series/page'));
const SeriesDetailPage = lazy(() => import('../pages/series/[id]/page'));
const SearchPage = lazy(() => import('../pages/search/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/legal/terms/page'));
const PrivacyPage = lazy(() => import('../pages/legal/privacy/page'));
const PolicyPage = lazy(() => import('../pages/legal/policy/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ToolsPage = lazy(() => import('../pages/tools/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const W = ({ children }: { children: React.ReactNode }) => (
  <React.Suspense fallback={null}>{children}</React.Suspense>
);

const routes: RouteObject[] = [
  { path: '/', element: <W><HomePage /></W> },
  { path: '/articles', element: <W><PostsPage /></W> },
  { path: '/articles/:slug', element: <W><PostDetailPage /></W> },
  { path: '/posts', element: <W><PostsPage /></W> },
  { path: '/posts/:slug', element: <W><PostDetailPage /></W> },
  { path: '/categories', element: <W><CategoriesPage /></W> },
  { path: '/categories/:slug', element: <W><CategoryDetailPage /></W> },
  { path: '/series', element: <W><SeriesPage /></W> },
  { path: '/series/:id', element: <W><SeriesDetailPage /></W> },
  { path: '/search', element: <W><SearchPage /></W> },
  { path: '/about', element: <W><AboutPage /></W> },
  { path: '/tools', element: <W><ToolsPage /></W> },
  { path: '/contact', element: <W><ContactPage /></W> },
  { path: '/legal/terms', element: <W><TermsPage /></W> },
  { path: '/legal/privacy', element: <W><PrivacyPage /></W> },
  { path: '/legal/policy', element: <W><PolicyPage /></W> },
  { path: '*', element: <W><NotFoundPage /></W> },
  // Admin
  { path: '/admin/login', element: <W><AdminLoginPage /></W> },
  { path: '/admin', element: <W><AdminDashboardPage /></W> },
  { path: '/admin/posts', element: <W><AdminPostsPage /></W> },
  { path: '/admin/posts/new', element: <W><AdminPostEditPage /></W> },
  { path: '/admin/posts/:slug', element: <W><AdminPostEditPage /></W> },
  { path: '/admin/home', element: <W><AdminHomePage /></W> },
  { path: '/admin/series', element: <W><AdminSeriesPage /></W> },
  { path: '/admin/categories', element: <W><AdminCategoriesPage /></W> },
  { path: '/admin/settings', element: <W><AdminSettingsPage /></W> },
];

export default routes;